// Single source of truth for all pipeline select options.
// Consumed by: AddOpportunity, StageCellEditor, PropertyDashboard.
//
// Stage values must stay in sync with PIPELINE_STAGES in config.js.

// ── Stage ─────────────────────────────────────────────────────────────────────

export const ACQUISITION_OPTIONS = [
  { value: 'new_lead',        label: 'New Lead'       },
  { value: 'contacted',       label: 'Contacted'      },
  { value: 'nurture_lead',    label: 'Nurture Lead'   },
  { value: 'analyzing_deal',  label: 'Analyzing Deal' },
  { value: 'offer_made',      label: 'Offer Made'     },
  { value: 'due_diligence',   label: 'Due Diligence'  },
  { value: 'under_contract',  label: 'Under Contract' },
]

export const ACTIVE_OPTIONS = [
  { value: 'pre_construction',   label: 'Pre-Construction'   },
  { value: 'under_construction', label: 'Under Construction' },
  { value: 'finishing',          label: 'Finishing'          },
  { value: 'completed',          label: 'Completed'          },
]

export const DISPOSITION_OPTIONS = [
  { value: 'pre_listing',    label: 'Pre-Listing'    },
  { value: 'active_listing', label: 'Active Listing' },
  { value: 'pending',        label: 'Pending'        },
  { value: 'sold',           label: 'Sold'           },
]

export const STAGE_OPTIONS = [
  { key: 'acquisitions',  label: 'Acquisitions',  options: ACQUISITION_OPTIONS  },
  { key: 'projects',      label: 'Projects',       options: ACTIVE_OPTIONS       },
  { key: 'dispositions',  label: 'Dispositions',   options: DISPOSITION_OPTIONS  },
]

// ── Strategy ──────────────────────────────────────────────────────────────────

export const RESALE_OPTIONS = [
  { value: 'fix_flip',   label: 'Fix & Flip' },
  { value: 'wholesale',  label: 'Wholesale'  },
  { value: 'wholetail',  label: 'Wholetail'  },
]

export const RENTAL_OPTIONS = [
  { value: 'brrrr',              label: 'BRRRR'             },
  { value: 'long_term_rental',   label: 'Long-Term Rental'  },
  { value: 'short_term_rental',  label: 'Short-Term Rental' },
]

export const CONSTRUCTION_OPTIONS = [
  { value: 'build_to_rent', label: 'Build to Rent' },
  { value: 'build_to_sell', label: 'Build to Sell' },
]

export const STRATEGY_OPTIONS = [
  { label: 'Resale',           options: RESALE_OPTIONS       },
  { label: 'Rental',           options: RENTAL_OPTIONS       },
  { label: 'New Construction', options: CONSTRUCTION_OPTIONS },
]
